import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
//style
import './styles.css';

class Createaddress extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    let apiURL = "/aemData/formData/json_create-address";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("create-", "edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
        this.setState({ formJson: data });
      });
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiUrl) => {
    if (this.props.history.location.pathname.includes("sow-body")) {

      let agentDetail = this.props.sowEntities.filter(entity => {
        return entity.agent
      })

      var requestData = {
        ...this.state.formData,
        entityId: agentDetail[0].id
      };
      // requestData.entityId = this.props.currentCustomerDetails.data.id;
      if (this.props.mode === 'edit') {
        apiUrl = '/sowaddress/' + this.state.formData.id;
      }
      else {
        apiUrl = '/sowaddress'
      }

      var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
      eapiClient(apiUrl, {
        method: METHOD,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData)
      })
        .then(({ data }) => {
          var key = window.sessionStorage.getItem("getCurrentDropDown");
          window.sessionStorage.setItem('key' + key, data.responseData.id);
          this.props.history.goBack();
        });

    } else {
      var requestData = {
        ...this.state.formData,
        caseId: this.props.currentCustomerDetails.data.caseId
      };
      requestData.entityId = this.props.currentCustomerDetails.data.id;
      if (this.props.mode === 'edit') {
        apiUrl = apiUrl + "/" + this.state.formData.id;
      }

      var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
      eapiClient(apiUrl, {
        method: METHOD,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData)
      })
        .then(({ data }) => {
          var key = window.sessionStorage.getItem("getCurrentDropDown");
          window.sessionStorage.setItem('key' + key, data.responseData.id);
          this.props.history.goBack();
        });
    }


  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    if (this.props.currentAddress !== undefined) {
      formData = { ...this.props.currentAddress };
    } else {
      formData = {};
    }
    const properties = {
      addressId: this.props.match.params.addressId,
      addressType: this.props.match.params.addressType,
      formData,
      editType: 'create-new-address',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          history={this.props.history}
          match={this.props.match}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}



const mapStateToProps = (state, props) => {
  let currentAddress = undefined;
  if (props.match.params) {
    var { addressId } = props.match.params;
    if (addressId && state.addresses.length > 0) {
      state.addresses.forEach(address => {
        if (address.id === addressId) {
          currentAddress = address;
        }
      });
    }
  }
  return {
    currentAddress,
    mode: currentAddress !== undefined ? 'edit' : '',
    currentCustomerDetails: state.currentCustomerDetails,
    lang: state.lang,
    sowEntities: (state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity) || [],
  };
}

export default connect(mapStateToProps)(Createaddress);



// WEBPACK FOOTER //
// ./src/components/CaseBody/CustomerDetails/CaptureCustomerDetails/CreateNewAddress.js